var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgAnalytics = function SvgAnalytics(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    viewBox: "0 0 24 24"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1 0a1 1 0 0 1 1 1v18a3 3 0 0 0 3 3h18a1 1 0 0 1 0 2H5a5.007 5.007 0 0 1-5-5V1a1 1 0 0 1 1-1"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M6 11a1 1 0 0 1 1 1v7a1 1 0 0 1-2 0v-7a1 1 0 0 1 1-1M11 9a1 1 0 0 1 1 1v9a1 1 0 0 1-2 0v-9a1 1 0 0 1 1-1M16 12a1 1 0 0 1 1 1v6a1 1 0 0 1-2 0v-6a1 1 0 0 1 1-1M21 8a1 1 0 0 1 1 1v10a1 1 0 0 1-2 0V9a1 1 0 0 1 1-1M22.996.013a1 1 0 0 1 .711 1.694l-5.586 5.586a3 3 0 0 1-4.242 0l-2.172-2.172a1.025 1.025 0 0 0-1.414 0L6.707 8.707a1 1 0 0 1-1.414-1.414l3.586-3.586a3 3 0 0 1 4.242 0l2.172 2.17a1 1 0 0 0 1.414 0L22.293.294a1 1 0 0 1 .703-.28"
  })));
};
export default SvgAnalytics;